export default __webpack_public_path__ + "img/bPGJFcPd.d4336d00.svg";